import * as React from "react";
import { FlexContainer } from "~/components";
import { PagerDutyBusinessServiceDelete } from "~/components/PagerDutyBusinessServices/PagerDutyBusinessServiceDelete";
import { EditPagerDutyBusinessService } from "~/components/PagerDutyBusinessServices/PagerDutyBusinessServiceEdit";
import { PagerDutyBusinessService } from "~/models/pagerDutyBusinessService";

export const PagerDutyBusinessServiceListColumns = (
  fetchPDBusinessServices: () => void,
  canEdit: boolean,
  removePDBusinessService: (id: string) => Promise<void>,
  fetchCustomer: () => void
) => [
  {
    Header: "Tenant",
    accessor: "tenant",
  },
  {
    Header: "Business Service",
    accessor: "name",
    Cell: ({ value }: { value: string }) => <span>{value}</span>,
  },
  {
    Header: "Reporting Start Date",
    accessor: "reportingStartDate",
    Cell: ({ value }: { value: string | null }) => (
      <span>{value || "N/A"}</span>
    ),
  },
  {
    Header: "Reporting End Date",
    accessor: "reportingEndDate",
    Cell: ({ value }: { value: string | null }) => (
      <span>{value || "N/A"}</span>
    ),
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
    Cell: ({ row }: { row: { original: PagerDutyBusinessService } }) => (
      <FlexContainer>
        {canEdit && (
          <>
            <EditPagerDutyBusinessService
              businessService={row.original}
              refetch={fetchPDBusinessServices}
              fetchCustomer={fetchCustomer}
              disabled={!canEdit}
            />
            <PagerDutyBusinessServiceDelete
              businessService={row.original}
              removeCallback={removePDBusinessService}
              disabled={!canEdit}
            />
          </>
        )}
      </FlexContainer>
    ),
  },
];
